import React from 'react';
import PropTypes from 'prop-types';

// Color convention (confirmed with client — blue and orange are the app's
// two main brand colors, orange being the logo's secondary color, so both
// stay in active use rather than being reduced to one "primary" color):
//   primary (blue)    - default action in a flow: Save / Submit / Confirm
//   secondary (orange) - brand-accent action worth visual emphasis: Add, Generate, Export
//   cancel (white)     - dismiss / back out, never a destructive or brand-accent action
//   danger (red)       - destructive action
//   success (green)    - confirmation state
const Button = ({ color = 'primary', className = '', size = 'medium', children, tooltip = '', onClick = () => {}, ...props }) => {
    const buttonClasses = ` ${getColorClass(color)} ${getSizeClass(size)} ${props.disabled ? "opacity-40" : "hover:opacity-80"} h-11 p-1.5 transition-opacity duration-200 rounded-[15px] shadow border border-gray-100 justify-center items-center gap-2.5 inline-flex text-sm font-bold font-['Product Sans'] leading-tight ${className}`;

    function getColorClass(color) {
        switch (color) {
            case 'primary':
                return 'bg-[#0071BC] text-white';
            case 'secondary':
                return 'bg-[#EF8400] text-white';
            case 'success':
                return 'bg-green-500 text-white';
            case 'danger':
                return 'bg-red-500 text-white';
            case 'cancel':
                return 'bg-white text-gray-700';
            default:
                return '';
        }
    }

    function getSizeClass(size) {
        switch (size) {
            case 'small':
                return 'text-sm';
            case 'large':
                return 'text-lg w-[200px]';
            case 'medium':
                return 'text-lg w-[150px]';
            default:
                return 'text-base';
        }
    }

    return (
        <button
            className={`${buttonClasses} px-4 py-2 rounded-2xl ${className}`}
            title={tooltip}
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    color: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'cancel']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    tooltip: PropTypes.string, // Added prop type for tooltip
};

export default Button;
